// importation des bibliothèques de modules node
import React, { useEffect, useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';

// importation du profil layout wrapper
import PersonnelProfileLayout from './PersonnelProfileLayout';

import PersonnelService from '../../services/PersonnelService';

const ArchivePersonnel = () => {
	const [personnel, setPersonnel] = useState(null);
	const { id } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		Promise.all([PersonnelService.getPersonnel(id)]).then(([personnelData]) => {
			setPersonnel(personnelData.data);
		});
	}, [id]);

	const handleSubmit = async (event) => {
		event.preventDefault();
		try {
			const personnelData = new FormData();

			personnelData.append('archived', true);

			// Call the PersonnelService to delete the personnel
			await PersonnelService.updatePersonnel(id, personnelData);

			// Redirect the user to the list of personnels
			navigate('/administration/personnel');
		} catch (error) {
			console.error(
				"Erreur lors de la l'archivage des informations de ce personnel",
				error
			);
		}
	};

	return (
		<PersonnelProfileLayout>
			{personnel && (
				<>
					{/*  Form  */}
					<Form className="mb-3" onSubmit={handleSubmit}>
						<Card className="border-0">
							<Card.Header>
								<div className="mb-3 mb-lg-0">
									<h3 className="mb-0">
										Archiver{' '}
										<span className="text-uppercase">
											{personnel.nom || ''}
										</span>
									</h3>
									<p className="mb-0">Archiver le profil de ce personnel.</p>
								</div>
							</Card.Header>
							<Card.Body>
								<span className="text-warning h4">Attention</span>
								<p>
									Si vous archivez le profil de ce personnel, il n'apparaitra
									plus dans la liste des personnels de l'établissement. Il sera
									possible tout de même possible de voir les informations de
									ce personnel dans le menu Anciens personnels.
								</p>
								<Button variant="warning" type="submit">
									Achiver le profil de ce personnel
								</Button>
							</Card.Body>
						</Card>
					</Form>
				</>
			)}
		</PersonnelProfileLayout>
	);
};

export default ArchivePersonnel;
